module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-text-fill-3440405e.svg";